import React from "react";

export default function Policy() {
  return (
    <div className="page">
      <h1>HR Policy Formulation</h1>
      <p>Policy formulation placeholder.</p>
    </div>
  );
}
